module.exports = __webpack_public_path__ + "static/img/pic_girl2.81d6b51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic_girl2.png
// module id = ssC0
// module chunks = 1